import classnames from 'classnames';
import { FC, RefAttributes, SVGProps } from 'react';

import styles from './logo.module.scss';
import { LogoProps, LogoType } from './logo.types';

export const Logo =
  (
    LogoElementProd: FC<SVGProps<SVGSVGElement> & RefAttributes<SVGSVGElement>>,
    LogoElementUat: FC<SVGProps<SVGSVGElement> & RefAttributes<SVGSVGElement>>
  ): LogoType =>
  ({ variant = 'prod', size = 'medium', className, ...props }: LogoProps) => {
    const LogoElement = variant === 'prod' ? LogoElementProd : LogoElementUat;
    return <LogoElement className={classnames(styles.logo, className, styles[size])} {...props} />;
  };
